import { App, type URLOpenListenerEvent } from '@capacitor/app';
import { isNative } from './platform';

const WEB_ORIGINS = [
  'https://getpulsemd.com',
  'https://www.getpulsemd.com',
];
const APP_SCHEME = 'com.pulsemd.app://';

/**
 * Extract the in-app path from an inbound deep link URL.
 * Returns null if the URL doesn't belong to PulseMD.
 */
export function parseDeepLink(url: string): string | null {
  for (const origin of WEB_ORIGINS) {
    if (url.startsWith(origin)) {
      const remainder = url.slice(origin.length);
      return remainder.length === 0 ? '/' : remainder;
    }
  }
  if (url.startsWith(APP_SCHEME)) {
    const remainder = url.slice(APP_SCHEME.length);
    return remainder.length === 0 ? '/' : '/' + remainder;
  }
  return null;
}

/**
 * Register the Capacitor App.appUrlOpen listener.
 * Calls `navigate` with the in-app path whenever a deep link arrives.
 * Returns a cleanup function. No-op on web.
 */
export function registerDeepLinkHandler(navigate: (path: string) => void): () => void {
  if (!isNative()) return () => {};

  const handler = (event: URLOpenListenerEvent) => {
    const path = parseDeepLink(event.url);
    if (path) navigate(path);
  };

  const listenerHandle = App.addListener('appUrlOpen', handler);

  return () => {
    void listenerHandle.then((h) => h.remove());
  };
}
